module.exports = __webpack_public_path__ + "img/model_provider_arrow-o.e4917cf4.svg";